export interface CustomerLogo {
  name: string;
  /** Approved, locally hosted logo, relative to the public base path. */
  image: string;
}

export interface CustomerTestimonial {
  quote: string;
  name: string;
  attribution?: string;
  rating?: 1 | 2 | 3 | 4 | 5;
  /** Approved customer portrait or studio photograph, relative to the public base path. */
  image?: string;
  imageAlt?: string;
}

// Publish only customer-supplied endorsements with permission to use the names,
// quotations, and images. Empty collections deliberately render no proof claims.
export const customerLogos: readonly CustomerLogo[] = [];
export const customerTestimonials: readonly CustomerTestimonial[] = [
  {
    quote: "I fit in two more appointments on busy days. It’s a huge time-saver.",
    name: "Toni",
    rating: 5,
    image: "landing/artists/toni.webp",
    imageAlt: "Toni, tattoo artist",
  },
  {
    quote: "Clean linework saves me prep time, so I can focus on the details that matter.",
    name: "Willi",
    rating: 5,
    image: "landing/artists/willi.webp",
    imageAlt: "Willi, tattoo artist",
  },
  {
    quote: "I spend less time tracing and more time tattooing. Sizing and export are straightforward.",
    name: "Alf",
    rating: 5,
  },
];
// Supply the business's actual https://www.trustpilot.com/review/... URL.
// No Trustpilot score, count, or verification claim is inferred from this link.
export const trustpilotProfileUrl: string | null = null;
